import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { Row, Col, Button } from 'react-bootstrap';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import BackIcon from '../../../../styles/images/back-without-bg.png';
import { handleChangeInputLoginPage, 
    handleChangeDisabledBtnPageLogin, 
    handleChangeLoaderPageLogin, 
    handleChangeBtnClassPageLogin } from "../../../../redux/actions/pages/user/login";
import { handleChangeTimerTimePageVerification } from "../../../../redux/actions/pages/user/verification";
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import Swal from 'sweetalert2';
import { BASE_SITE, LOGIN_OR_REGISTER_POST } from '../../../../apis'; 
import axios from "axios";
import * as qs from "querystring";

const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { phoneNumber, disabledBtn, isLoading, btnClass } = useSelector(state => state.login);

    const handleBackBtn = () => {
        navigate(-1);
    };

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });

    const validationPhoneNumber = (event) => {
        const {value: phone} = event.target;
        
        if(phone.length <= 11) {
            handleChangeInputPhonePageLogin(phone);

            if (phone.length === 11) {
                if (disabledBtn) {
                    dispatch(handleChangeDisabledBtnPageLogin(false));
                }
                dispatch(handleChangeBtnClassPageLogin(''));
            } 
            else {
                dispatch(handleChangeBtnClassPageLogin('disable-btn'));
                if (!disabledBtn)
                    dispatch(handleChangeDisabledBtnPageLogin(true));
            }
        }
        else
            btnOkSingle.fire({
                title: "خطا در ورود",
                text: "شماره موبایل نباید بیشتر از 11 رقم باشد.",
                imageUrl: SitagLogo,
                imageHeight: 80,
                imageAlt: 'سیتگ',
                confirmButtonText: "باشه",
            });
    };

    const handleChangeInputPhonePageLogin = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "phoneNumber", value: event} : event.target;
        dispatch(handleChangeInputLoginPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }


    const handleBtnFormLogin = (event) => {
        event.preventDefault();

        apiLoginOrRegister();
    };


    const apiLoginOrRegister = () => {
        dispatch(handleSetBackdropLoading(true));
        dispatch(handleChangeLoaderPageLogin(true));
        dispatch(handleChangeDisabledBtnPageLogin(true));

        axios({
            method: 'post',
            url: BASE_SITE + LOGIN_OR_REGISTER_POST,
            data: qs.stringify({
                mobile: phoneNumber,
                introduced_code:'',
            }), headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    btnOkSingle.fire({
                        title: "خطا در ورود",
                        text: response.data.message,
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "تایید",
                    });
                    break;
                case 'ok':
                    dispatch(handleChangeTimerTimePageVerification(parseInt(response.data.timer_time)));
                    navigate(`../verification`);
                    break;
                default:
                    btnOkSingle.fire({
                        title: "خطا در ورود",
                        text: "لطفا مجددا تلاش کنید.",
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "تایید",
                    });
            }
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleChangeLoaderPageLogin(false));
            dispatch(handleChangeDisabledBtnPageLogin(false));
        }, () => {
            btnOkSingle.fire({
                title: "خطا در ورود",
                text: "لطفا مجددا تلاش کنید.",
                imageUrl: SitagLogo,
                imageHeight: 80,
                imageAlt: 'سیتگ',
                confirmButtonText: "تایید",
            });
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleChangeLoaderPageLogin(false));
            dispatch(handleChangeDisabledBtnPageLogin(false));
        });
    };

    return (

        <div id="login-page">
            <Row className="pt-5">
                <Col xs={1} className="d-flex align-items-center"><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10} className="text-center">
                    <div className="header_h3">
                        به 
                        <Link to=".."><img src={SitagLogo} className="logo-in-txt mx-2" alt="سیتگ" /></Link>
                        خوش آمدید
                    </div>
                </Col>
                <Col xs={1}></Col>
                <Col xs={12} className="header_h4 text-center mt-1">
                    شماره موبایل خود را وارد کنید
                </Col>
            </Row>

            <Row className="mt-4">
                <Col className="text-center mt-4">
                    <div className="input-wrapper" >
                        <label className="label-wrapper ml-3" htmlFor="first" >شماره موبایل</label>
                        <input type="number" 
                                value={phoneNumber} 
                                onChange={validationPhoneNumber} 
                                className="w-100 px-2 form-input custom-input custom-vertical-padding" />
                    </div>
                </Col>
            </Row>

            <Row className="mt-1">
                <Col className="text-center mt-4">
                    <Button className={`w-100 custom-vertical-padding login-form-button ${btnClass}`} disabled={disabledBtn} onClick={handleBtnFormLogin}>
                        دریافت کد تایید
                    </Button>
                </Col>
            </Row>

        </div>

    );
}

export default Login;